import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileChart: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFileChart"><Path d="M13 2.5H4.5V21.5H19.5V9L13 2.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 17.5V15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 17.5V12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 17.5V14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13 3V9H19" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFileChart;
